const closings_route = "/closings";

export const ROUTES = {
  closings: {
    sidebarLabel: "Closings",
    buyerListing: {
      label: "Buyer Listing",
      route: `${closings_route}/buyer-listing`,
    },
    myConcierge: {
      label: "Concierge Dashboard",
      route: `${closings_route}/concierge-dashboard`,
    },
    conciergeAssignment: {
      label: "Concierge Assignment",
      route: `${closings_route}/concierge-assignment`,
    },
    overview: {
      label: "Overview",
      route: `${closings_route}/overview`,
    },
    reports: {
      label: "Homesites Report",
      route: `${closings_route}/reports`,
    },
    tasks: {
      label: "Tasks",
      route: `${closings_route}/tasks`,
    },
  },
  settings: {
    division: {
      label: "Division Settings",
      route: "divisionSettings",
    },
  },
  viewFeedback: {
    feedback: {
      label: "Feedback Management",
      route: "viewFeedback",
    },
  },
  permissionDenied: {
    permissionDenied: {
      label: "Permission Denied",
      route: "permission-denied",
    },
  },
  login: {
    route: "/login",
  },
  loginCallback: {
    route: "/login/callback",
  },
  logout: {
    route: "/logout",
  },
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const noteTypes = {
  COMMUNITY: "Community",
  HOMESITE: "Homesite",
};

export const permissionValues = [
  { label: "LOS-CLO-USER-RW-DEV", value: "RW" },
  { label: "LOS-CLO-USER-RO-DEV", value: "RO" },
  { label: "LOS-CLO-APP-ADMIN-DEV", value: "ALL" },
  { label: "LOS-CLO-DIV-ADMIN-DEV", value: "DIV" },
];

export const faqUrl =
  "https://lennarcorporation.sharepoint.com/sites/SMARTHub/SitePages/StartsExpediterProgram.aspx?xsdata=MDV8MDF8fGJhNWI4OWQ2Yzg5MDRjODM4ZTEzMDhkYmQzYzY1OWFkfDI4ZTU0NmM3ZmQ0YjQyNDZiMGMxYzgwMGQ2MzgxZDdkfDB8MHw2MzgzMzY2MjEwNjQ1ODg4MTl8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxMMk5vWVhSekx6RTVPamhpT0RWbFlqRXdMV1JqT1dFdE5HSm1ZaTA0WldRM0xXWTROV1F3Tm1NMlpUbGpNMTlpWWpaaU5UVTBZaTFqWmpGaUxUUXpZalV0T1dSbFlTMHhNall5WXpJek16RTBaREJBZFc1eExtZGliQzV6Y0dGalpYTXZiV1Z6YzJGblpYTXZNVFk1T0RBMk5UTXdOVEF3TlE9PXxlYTc5MzE0MzAwNjk0ZmRkOGUxMzA4ZGJkM2M2NTlhZHwyNzE3N2FiNjgzYzE0NzQ4OTk0OGI5YTVkNWU0YzFhMA%3D%3D&sdata=aU1LMlRONjVWd1UwdWduNXpxVGp6YndRMnh5UGJKMEdPUEZoTVFiZU83RT0%3D&ovuser=28e546c7-fd4b-4246-b0c1-c800d6381d7d%2Ctheresa.gallup%40lennar.com";

export const checkboxColumn = {
  field: "checkbox",
  headerName: "",
  width: "20",
  type: "checkbox",
};

export const APPLY = "apply";

export const paramTasksPeriod = "timePeriod";
export const paramsTasksListingValues = {
  allTasks: "allTasks",
  dueToday: "dueToday",
  dueThisWeek: "dueThisWeek",
  dueNextWeek: "dueNextWeek",
  dueThisMonth: "dueThisMonth",
  withoutDueDate: "withoutDueDate",
};

export const paramBuyerListingPeriod = "timePeriod";
export const paramBuyerListingTab = "tabSelected";
export const paramsBuyerListingValues = {
  newSalesLast7Days: "newSalesLast7Days",
  weeklyUpdate: "weeklyUpdate",
  closingsIn14Days: "closingsIn14Days",
  closingsThisMonth: "closingsThisMonth",
  closingsIn60Days: "closingsIn60Days",
  closingsIn30Days: "closingsIn30Days",
  closedHomes: "closeHomeSites",
  allBuyers: "allBuyers",
  ecoeMismatch: "ecoeMismatch",
};
export const buyerListingTitleTabs = {
  myView: "My View",
  buyerDetails: "Buyer Details",
  homesiteDetails: "Homesite Details",
  mortgageTitleDetails: "Mortgage and Title Details",
  oslDetails: "OSL Details",
};

export const myConciergeStorage = "myConciergeDropdownSelected";
export const myOverviewLabel = "My Overview";
export const buyerListingMyViewTableName = "buyerListingMyViewTable";

export const allConcierges = {
  label: "All Concierges",
  value: "all",
};

export const myDivision = {
  label: "My Division",
  value: "myDivision",
};

export const emptyDialogSelectConcierge = {
  title: "",
  description: "",
  labelSubmitButton: "",
  submitAction: () => {},
};

export const localStorageCeUserId = "ceUserId";
export const localStorageCeUserName = "ceUserName";

export const titleOptionsDropdown = {
  allBuyers: "All buyers",
  sevenDays: "New sales in previous 7 days",
  sixtyDays: "Closings in 60 days",
  thirtyDays: "Closings in 30 days",
  twoWeeks: "Closings in next 14 days",
  thisMonth: "Closings this month",
  closedHomesites: "Homesites closed in the last 30 days",
  weeklyUpdateHomesites: "Buyers needing a weekly update",
  ecoeMismatch: "Homesites with ECOE Mismatches"
};

export const GeneralComments = "General Comments";
export const HOMESITE_NOTES_MAX_LENGTH = 1000;

// Constants for Active and Resolved Status and auto Resolved status for Alerts
export const ALERT_ACTIVE_STATUS = "active";
export const ALERT_RESOLVED_STATUS = "resolved";
export const ALERT_AUTORESOLVED_STATUS = "auto Resolved";
export const NOTES = "notes";
export const ALERTS = "alerts";
export const EXCEPTIONS = "exceptions";
export const DEFAULT_VIEW_NAME = "Default View";
export const ALL_MILESTONES = "all"
export const DIVISION_SETTINGS_TEXTFIELD_LIMIT = 75;
export const DIVISION_SETTINGS_MAX_NUMBER_OF_ADDITIONAL_TASKS = 10;
export const DIVISION_SETTINGS_MAX_NUMBER_OF_ADDITIONAL_MILESTONES = 5;
export const INVALID_MILESTONE_TASK_NAME_MATCH = "Milestone and task names cannot match";
export const INVALID_TASK_EXISTS_IN_MILESTONE = "Task already exists";
export const INVALID_MILESTONE_NAME_EXISTS_IN_DIVISION = "Milestone already exists";
export const STANDARD_HEIGHT_OF_DROPDOWN = 250;